import { Box, Container, Divider, Link, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../../theme/colors';

const FOOTER_LINKS = [
  {
    key: 'whatsapp',
    href: 'https://wa.me/qr/L4AFRVDY5YKKI1',
  },
  {
    key: 'instagram',
    href: 'https://www.instagram.com/lexnova_ai?igsh=MWFheGFkb2llcXY5cQ==',
  },
  {
    key: 'facebook',
    href: 'https://www.facebook.com/share/1DGBvnjBE7/',
  },
] as const;

export default function Footer(): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      component="footer"
      sx={{
        background: isDark ? COLORS.dark[900] : COLORS.gray[900],
        color: '#fff',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={isDark ? '/assets/logo-blanco.svg' : '/assets/logo.svg'}
            alt="LexNova"
            sx={{
              height: { xs: 30, md: 34 },
              width: 'auto',
              display: 'block',
              objectFit: 'contain',
            }}
          />

          {/* Social links */}
          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
            {FOOTER_LINKS.map((link) => (
              <Link
                key={link.key}
                href={link.href}
                underline="none"
                target="_blank"
                rel="noreferrer"
                sx={{
                  color: COLORS.gray[400],
                  fontSize: '0.875rem',
                  transition: 'color 0.2s',
                  '&:hover': { color: COLORS.purple[400] },
                }}
              >
                {t(`footer.links.${link.key}`)}
              </Link>
            ))}

            <Link
              href="https://www.lexnova.cloud"
              underline="none"
              target="_blank"
              rel="noreferrer"
              sx={{
                color: COLORS.purple[400],
                fontSize: '0.875rem',
                transition: 'color 0.2s',
                '&:hover': { color: COLORS.magenta[400] },
              }}
            >
              {t('footer.links.website')}
            </Link>
          </Box>
        </Box>

        <Divider sx={{ my: 2, borderColor: COLORS.dark[400] }} />

        <Typography
          variant="body2"
          sx={{
            color: COLORS.gray[500],
            fontSize: '0.8rem',
            textAlign: 'center',
          }}
        >
          {t('footer.copyright')}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: COLORS.gray[500],
            fontSize: '0.78rem',
            textAlign: 'center',
            mt: 1,
          }}
        >
          This page was made by{' '}
          <Link
            href="https://original-dev.com"
            target="_blank"
            rel="noreferrer"
            underline="none"
            sx={{
              color: COLORS.purple[400],
              fontWeight: 500,
              transition: 'color 0.2s',
              '&:hover': { color: COLORS.magenta[400] },
            }}
          >
            Original & Dev
          </Link>{' '}
          (
          <Link
            href="https://github.com/Original-Dev"
            target="_blank"
            rel="noreferrer"
            underline="none"
            sx={{
              color: COLORS.purple[400],
              fontWeight: 500,
              transition: 'color 0.2s',
              '&:hover': { color: COLORS.magenta[400] },
            }}
          >
            O&amp;D
          </Link>
          ).
        </Typography>
      </Container>
    </Box>
  );
}